import { BlogSection } from '@/types/blog';

export const zenHaltungSection: BlogSection = {
  id: 'zen-haltung',
  title: 'Zen als Haltung – nicht als Religion',
  content: `
    <p>
      Zen ist eine Praxis des Sehens, Fühlens und bewussten Handelns. Eine Philosophie, die mich lehrt: „Tue nichts, was dir oder anderen schadet." Nicht aus Pflicht, sondern aus Klarheit. Zen bringt mich zurück zur Langsamkeit vor dem Urteil und zur Frage: Was tue ich gerade wirklich mit meinen Worten und meinem Einfluss?
    </p>
  `
};
